import React from 'react'

const TrustBar = () => {

    const stats = [
        { value: "20+", label: "Years Enterprise Engineering" },
        { value: "600k+", label: "Lines of Code Migrated (WebSphere to Spring Boot)" },
        { value: "100%", label: "Test Coverage on Security Critical Auth" },
        { value: "0", label: "Business Stoppages during Major Overhauls" }
    ];

    return (
        <React.Fragment>
            <div className="bg-slate-100 border-y border-slate-200 py-10">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-4">
                        {stats.map((stat, idx) => (
                            <div key={idx} className="flex flex-col items-center text-center lg:items-start lg:text-left border-slate-300 last:border-0 md:px-4">
                                <span className="text-5xl font-bold text-navy-950 mb-1 font-mono">{stat.value}</span>
                                <span className="text uppercase tracking-wider text-slate-500 font-semibold leading-tight">{stat.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

TrustBar.propTypes = {
}

export default TrustBar


